import * as React from "react";
const SvgChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10.8, height: 6.8, viewBox: "0 0 10.8 6.8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.4 6.8L5.4 2.8L1.4 6.8L0 5.4L5.4 0L10.8 5.4L9.4 6.8Z", fill: "currentColor" }));
export default SvgChevronUp;
